// extracted by mini-css-extract-plugin
export default {"legendPopup":"ConfigPopup_legendPopup__FeL-+"};